import 'braid-design-system/reset';
import { BraidProvider } from 'braid-design-system';
import seekJobs from 'braid-design-system/themes/seekJobs';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';

import { App } from './App/App';

const rootElement = document.getElementById('app');

export default () =>
  hydrateRoot(
    rootElement!,
    <HelmetProvider>
      <BrowserRouter>
        <BraidProvider theme={seekJobs}>
          <App />
        </BraidProvider>
      </BrowserRouter>
    </HelmetProvider>,
  );
